import { PageModel } from "./PageModel";

class BeforeAfterPhotosController extends PageModel {

}

export { BeforeAfterPhotosController }
